import { ReplaySubject } from 'rxjs';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { environment } from '../../environments/environment';
import {Document } from '../_models';

@Injectable({ providedIn: 'root' })
export class SignatureService {

    public signDoc: ReplaySubject<any> = new ReplaySubject<any>(1);

    constructor(
        private http: HttpClient,
        private router: Router) { }
    
    padesSignaturePostInit(data: any){
        return this.http.post(`${environment.baseUrl}/arquivamento/async`, data);
    }

    padesSignaturePostEnd(data: any){
        return this.http.post(`${environment.baseUrl}/sign/`, data);
    }

    setSignDoc(doc: any){
        this.signDoc.next(doc);
    }

    getCurrentSignDoc(){
        return this.signDoc;
    }

    
}